// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
@keyframes list-fill {
  0% {
    opacity: 0;
    transform: translateX(30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes reverse-list-fill {
  0% {
    opacity: 0;
    transform: translateX(-30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
app-root .layout-page ul.seating-layouts {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}
app-root .layout-page ul.seating-layouts li {
  will-change: transform, opacity;
  animation: 0.3s ease-in-out normal backwards list-fill;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(1) {
  animation-delay: 0s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(2) {
  animation-delay: 0.06s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(3) {
  animation-delay: 0.12s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(4) {
  animation-delay: 0.18s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(5) {
  animation-delay: 0.24s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(6) {
  animation-delay: 0.3s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(7) {
  animation-delay: 0.36s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(8) {
  animation-delay: 0.42s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(9) {
  animation-delay: 0.48s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(10) {
  animation-delay: 0.54s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(11) {
  animation-delay: 0.6s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(12) {
  animation-delay: 0.66s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(13) {
  animation-delay: 0.72s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(14) {
  animation-delay: 0.78s;
}
app-root .layout-page ul.seating-layouts li:nth-of-type(15) {
  animation-delay: 0.84s;
}
@media (max-width: 599px) {
  app-root .layout-page ul.seating-layouts {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  app-root .layout-page ul.seating-layouts li {
    display: flex;
  }
  app-root .layout-page ul.seating-layouts li > .radio-button,
  app-root .layout-page ul.seating-layouts li > .checkbox-button {
    display: flex;
    flex: 1;
    min-width: 0;
  }
  app-root .layout-page ul.seating-layouts li label {
    display: flex;
    align-items: center;
    flex: 1;
    text-align: left;
  }
}
app-root .layout-page.reverse-transitions ul.seating-layouts li {
  animation-name: reverse-list-fill;
}
app-root .layout-page ul.general-layouts {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}
app-root .layout-page ul.general-layouts li {
  will-change: transform, opacity;
  animation: 0.3s ease-in-out normal backwards list-fill;
}
app-root .layout-page ul.general-layouts li:nth-of-type(1) {
  animation-delay: 0s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(2) {
  animation-delay: 0.06s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(3) {
  animation-delay: 0.12s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(4) {
  animation-delay: 0.18s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(5) {
  animation-delay: 0.24s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(6) {
  animation-delay: 0.3s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(7) {
  animation-delay: 0.36s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(8) {
  animation-delay: 0.42s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(9) {
  animation-delay: 0.48s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(10) {
  animation-delay: 0.54s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(11) {
  animation-delay: 0.6s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(12) {
  animation-delay: 0.66s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(13) {
  animation-delay: 0.72s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(14) {
  animation-delay: 0.78s;
}
app-root .layout-page ul.general-layouts li:nth-of-type(15) {
  animation-delay: 0.84s;
}
@media (max-width: 599px) {
  app-root .layout-page ul.general-layouts {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  app-root .layout-page ul.general-layouts li {
    display: flex;
  }
  app-root .layout-page ul.general-layouts li > .radio-button,
  app-root .layout-page ul.general-layouts li > .checkbox-button {
    display: flex;
    flex: 1;
    min-width: 0;
  }
  app-root .layout-page ul.general-layouts li label {
    display: flex;
    align-items: center;
    flex: 1;
    text-align: left;
  }
}
app-root .layout-page.reverse-transitions ul.general-layouts li {
  animation-name: reverse-list-fill;
}
app-root .layout-page .seating-layout-section {
  margin-top: 24px;
}
app-root .layout-page .seating-layout-section legend {
  font-weight: 700;
  line-height: 1.5rem;
  margin-bottom: 1.5rem;
}
@media (min-width: 900px) {
  app-root .layout-page .seating-layout-section legend {
    font-size: 1.5rem;
    line-height: 1.25;
  }
}
app-root .layout-page .seating-layout-section .seating-layout {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  line-height: 1.6em;
}
app-root .layout-page .seating-layout-section .seating-layout svg {
  height: 1.6em;
  width: 1.6em;
  flex: none;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/FormSteps/Layout/LayoutInput.less","webpack://./src/Styles/buttonList.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;AC0CA;EACE;IACE,UAAA;IACA,0BAAA;EDxCF;EC2CA;IACE,UAAA;IACA,wBAAA;EDzCF;AACF;AC4CA;EACE;IACE,UAAA;IACA,2BAAA;ED1CF;EC6CA;IACE,UAAA;IACA,wBAAA;ED3CF;AACF;AAzBA;ECEM,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AD0BN;AAjCA;ECUQ,+BAAA;EACA,sDAAA;AD0BR;ADqDG;EACC,mBAAA;ACnDJ;ADkDG;EACC,sBAAA;AChDJ;AD+CG;EACC,sBAAA;AC7CJ;AD4CG;EACC,sBAAA;AC1CJ;ADyCG;EACC,sBAAA;ACvCJ;ADsCG;EACC,qBAAA;ACpCJ;ADmCG;EACC,sBAAA;ACjCJ;ADgCG;EACC,sBAAA;AC9BJ;AD6BG;EACC,sBAAA;AC3BJ;AD0BG;EACC,sBAAA;ACxBJ;ADuBG;EACC,qBAAA;ACrBJ;ADoBG;EACC,sBAAA;AClBJ;ADiBG;EACC,sBAAA;ACfJ;ADcG;EACC,sBAAA;ACZJ;ADWG;EACC,sBAAA;ACTJ;AClEM;EAAA;IACE,aAAA;IACA,qCAAA;IACA,SAAA;EDqEN;ECxEI;IAMI,aAAA;EDqER;EC3EI;;IAUM,aAAA;IACA,OAAA;IACA,YAAA;EDqEV;ECjFI;IAgBM,aAAA;IACA,mBAAA;IACA,OAAA;IACA,gBAAA;EDoEV;AACF;AC/DK;EACC,iCAAA;ADiEN;AA3GA;ECEM,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AD4GN;AAnHA;ECUQ,+BAAA;EACA,sDAAA;AD4GR;AD7BG;EACC,mBAAA;AC+BJ;ADhCG;EACC,sBAAA;ACkCJ;ADnCG;EACC,sBAAA;ACqCJ;ADtCG;EACC,sBAAA;ACwCJ;ADzCG;EACC,sBAAA;AC2CJ;AD5CG;EACC,qBAAA;AC8CJ;AD/CG;EACC,sBAAA;ACiDJ;ADlDG;EACC,sBAAA;ACoDJ;ADrDG;EACC,sBAAA;ACuDJ;ADxDG;EACC,sBAAA;AC0DJ;AD3DG;EACC,qBAAA;AC6DJ;AD9DG;EACC,sBAAA;ACgEJ;ADjEG;EACC,sBAAA;ACmEJ;ADpEG;EACC,sBAAA;ACsEJ;ADvEG;EACC,sBAAA;ACyEJ;ACpJM;EAAA;IACE,aAAA;IACA,qCAAA;IACA,SAAA;EDuJN;EC1JI;IAMI,aAAA;EDuJR;EC7JI;;IAUM,aAAA;IACA,OAAA;IACA,YAAA;EDuJV;ECnKI;IAgBM,aAAA;IACA,mBAAA;IACA,OAAA;IACA,gBAAA;EDsJV;AACF;ACjJK;EACC,iCAAA;ADmJN;AA7LA;EAKM,gBAAA;AA2LN;AAhMA;EAQQ,gBAAA;EACA,mBAAA;EACA,qBAAA;AA2LR;AAzLQ;EAAA;IACE,iBAAA;IACA,iBAAA;EA4LR;AACF;AA3MA;EAkBQ,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA4LR;AAjNA;EA2BU,aAAA;EACA,YAAA;EACA,UAAA;AAyLV","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../Styles/buttonList.less';\n@import '../../../Styles/mediaQueries.less';\n\napp-root {\n  .button-list-styles(layout-page, seating-layouts);\n  .button-list-styles(layout-page, general-layouts);\n  .layout-page {\n    .seating-layout-section {\n      margin-top: 24px;\n\n      legend {\n        font-weight: 700;\n        line-height: 1.5rem;\n        margin-bottom: 1.5rem;\n\n        @media @landscapeTabletUp {\n          font-size: 1.5rem;\n          line-height: 1.25;\n        }\n      }\n      .seating-layout {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.4em;\n        line-height: 1.6em;\n\n        // Tailwind preflight sets `svg { display: block }`, so the icon can no\n        // longer share a line box with the label text; the flex row above\n        // replaces the relative-offset nudges this used to rely on.\n        svg {\n          height: 1.6em;\n          width: 1.6em;\n          flex: none;\n        }\n      }\n    }\n  }\n}\n","@import './utilities.less';\n\n.button-list-styles(@page-class, @list-class, @base-delay: 0 ) {\n  .@{page-class} {\n    ul.@{list-class} {\n      display: flex;\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 16px;\n\n      li {\n        will-change: transform, opacity;\n        animation: 0.3s ease-in-out normal backwards list-fill;\n        .sequential-delay(15, 0.06s, ~'', @base-delay);\n      }\n\n      // Phones: one full-width list instead of centred rows of mixed widths\n      @media @mobile {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr);\n        gap: 10px;\n\n        li {\n          display: flex;\n\n          > .radio-button,\n          > .checkbox-button {\n            display: flex;\n            flex: 1;\n            min-width: 0;\n          }\n\n          label {\n            display: flex;\n            align-items: center;\n            flex: 1;\n            text-align: left;\n          }\n        }\n      }\n    }\n\n    &.reverse-transitions ul.@{list-class} li {\n      animation-name: reverse-list-fill;\n    }\n  }\n}\n\n@keyframes list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n\n@keyframes reverse-list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((-30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
